import React from 'react';
import useDeviceDetect from '../../hooks/useDeviceDetect';

const ResponsiveWrapper = ({ mobile, desktop, tablet }) => {
  const { isMobile, isTablet, isDesktop, screenSize } = useDeviceDetect();
  
  console.log('ResponsiveWrapper 상태:', { 
    isMobile, 
    isTablet, 
    isDesktop, 
    screenSize,
    hasMobile: !!mobile,
    hasDesktop: !!desktop,
    hasTablet: !!tablet,
    currentTime: new Date().toISOString()
  });

  if (isMobile && mobile) {
    console.log('모바일 컴포넌트 반환');
    return mobile;
  }

  if (isTablet && tablet) {
    console.log('태블릿 컴포넌트 반환');
    return tablet;
  }

  if (isDesktop && desktop) {
    console.log('데스크톱 컴포넌트 반환');
    return desktop;
  }

  // 태블릿 컴포넌트가 없으면 데스크톱 컴포넌트를 보여줌
  if (isTablet && !tablet && desktop) {
    console.log('태블릿이지만 데스크톱 컴포넌트 반환');
    return desktop;
  }

  // 기본값으로 데스크톱 컴포넌트 반환
  console.log('기본값으로 컴포넌트 반환:', { desktop: !!desktop, mobile: !!mobile });
  return desktop || mobile || null;
};

export default ResponsiveWrapper;